module.exports = __webpack_public_path__ + "static/media/icon-park-solid_id-card.26f2184b.svg";